window.theme = window.theme || {}; 


// theme.Currency = (function() {
//   var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase
//   function formatMoney(cents, format) {
//     if (typeof cents === 'string') {
//       cents = cents.replace('.', '');
//     }
//     var value = '';
//     var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
//     var formatString = format || moneyFormat;

//     function formatWithDelimiters(number, precision, thousands, decimal) {
//       thousands = thousands || ',';
//       decimal = decimal || '.';

//       if (isNaN(number) || number === null) {
//         return 0;
//       }

//       number = (number / 100.0).toFixed(precision);

//       var parts = number.split('.');
//       var dollarsAmount = parts[0].replace(
//         /(\d)(?=(\d\d\d)+(?!\d))/g,
//         '$1' + thousands
//       );
//       var centsAmount = parts[1] ? decimal + parts[1] : '';

//       return dollarsAmount + centsAmount;
//     }

//     switch (formatString.match(placeholderRegex)[1]) {
//       case 'amount':
//         value = formatWithDelimiters(cents, 2);
//         break;
//       case 'amount_no_decimals':
//         value = formatWithDelimiters(cents, 0);
//         break;
//       case 'amount_with_comma_separator':
//         value = formatWithDelimiters(cents, 2, '.', ',');
//         break;
//       case 'amount_no_decimals_with_comma_separator':
//         value = formatWithDelimiters(cents, 0, '.', ',');
//         break;
//       case 'amount_no_decimals_with_space_separator':
//         value = formatWithDelimiters(cents, 0, ' ');
//         break;
//       case 'amount_with_apostrophe_separator':
//         value = formatWithDelimiters(cents, 2, "'");
//         break;
//     }

//     return formatString.replace(placeholderRegex, value);
//   }

//   return {
//     formatMoney: formatMoney
//   };
// })();

theme.Currency = (function() {

  var moneyFormat = '${{amount}}';

  function formatMoney(cents, format) {
    var formatString = format || moneyFormat;

    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) return 0;

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );

      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    return formatString.replace(/\{\{\s*(\w+)\s*\}\}/, function(match, key) {
      return formatWithDelimiters(cents, 2);
    });
  }

  return {
    formatMoney: formatMoney,
    setFormat: function(format) {
      moneyFormat = format; // 👈 allow update later
    }
  };

})();
 
 /*-----------------------------------
   Custom Cart Renuka
-----------------------------------*/

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const closeBtn = document.querySelector('[data-cart-drawer-close]');
  // const cartIcon = document.getElementById('custom-cart-drawer-icon');
  const cartIcon = document.getElementById('custom-cart-drawer-icon');
  if (cartIcon) {
    cartIcon.addEventListener('click', function (e) {
          e.preventDefault();      // stops default action (like link navigation)
          e.stopPropagation();     // stops bubbling to parent handlers
    openAndLoadCartDrawer();
    });

  }
  const itemsContainer = document.getElementById('CartDrawerItems');
  const totalElementYes = document.querySelector('[data-cart-drawer-total-yesVip]');
  const totalElementNo = document.querySelector('[data-cart-drawer-total-noVip]');
  const drawerFooter = document.querySelector('.drawer__footer');
  const drawerInfo = document.querySelector('.cart-drawer_info');
  const HeaderCartCount = document.getElementById('CartDrawerHeading');
  let qtyTimer = null;
  let isLoading = false;

  if (!drawer || !overlay || !itemsContainer) return;

  /*-----------------------------------
    Open drawer and load cart
  -----------------------------------*/
  async function openAndLoadCartDrawer() {
    body.classList.add('cart-drawer-open');
    drawer.classList.add('open');
    drawer.classList.add('open');

    overlay.classList.add('active');

    // show loader by default
    itemsContainer.innerHTML = `
      <div class="cart-drawer-loader">
        <div class="loader-spinner" style="display: block !important;"></div>
        <p>Loading cart products...</p>
      </div>
    `;

    await loadCartDrawer();
  }

  /*-----------------------------------
    Close drawer
  -----------------------------------*/
  function closeCartDrawer() {
    body.classList.remove('cart-drawer-open');
    drawer.classList.remove('open');
    overlay.classList.remove('active');
  }
  overlay.addEventListener('click', closeCartDrawer);
  /*-----------------------------------
    Fetch cart + product data
  -----------------------------------*/
  async function loadCartDrawer() {
    if (isLoading) return;
    isLoading = true;

    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const currency = cart.currency;

      const symbol = new Intl.NumberFormat('en', {
        style: 'currency',
        currency: currency
      })
      .formatToParts(1)
      .find(p => p.type === 'currency').value
      .replace(/[A-Z]/gi, '');

    const moneyFormat = `${symbol}{{amount}}`;
    console.log('UPDATED:', moneyFormat);
    theme.Currency.setFormat(moneyFormat);


      if (!cart.items.length) {
        HeaderCartCount.innerHTML = `<span class="bag-text">MY CART:</span> 0 ITEM`;
        itemsContainer.innerHTML = '<p style="text-align:center">Your cart is empty.</p>';
        drawerFooter.style.display = 'none';
        drawerInfo.style.display = 'none';
        totalElementYes.textContent = theme.Currency.formatMoney(0);
        // totalElementYes.textContent = 0
        // theme.Cart.prototype._setCartCountBubble(0);

        return;
      }
      HeaderCartCount.innerHTML = `
  <span class="bag-text">MY CART:</span> ${cart.item_count} ITEM${cart.item_count === 1 ? '' : 'S'}
`;

      // fetch compare_at_price for all items in parallel
      const productPromises = cart.items.map(async (item) => {
        try {
          const productRes = await fetch(`/products/${item.handle}.js`);
          const productData = await productRes.json();
          const variant = productData.variants.find(v => v.id === item.variant_id);
          return variant?.compare_at_price ? Number(variant.compare_at_price) : null;
        } catch {
          return null;
        }
      });
      const comparePrices = await Promise.all(productPromises);
      const html = cart.items.map((item, index) => {
        const comparePrice = comparePrices[index];
        // const itemPrice = theme.Currency.formatMoney(item.line_price);
        const itemPrice = theme.Currency.formatMoney(item.line_price);
        // const itemPrice = 89
        const comparePriceHTML = comparePrice
          ? `<span class="old-price">${theme.Currency.formatMoney(comparePrice * item.quantity)}</span>`
          : '';

        return `
          <div class="cart-drawer-item">
            <img src="${item.image}" alt="${item.product_title}">
            <div class="cart-drawer-item__details">
              <p>
                <span class="cart-drawer-item__title">${item.product_title}</span><br>
                ${item.variant_title}
              </p>
              <div style="display: flex; justify-content: space-between;">
                <div class="quantity-selector">
                  <button class="quantity-minus">-</button>
                  <input
                    class="quantity-input"
                    type="number"
                    value="${item.quantity}"
                    min="0"
                    data-quantity-input
                    data-quantity-item="${index + 1}">
                  <button class="quantity-plus">+</button>
                </div>
                <a class="text-link text-link--accent" data-cart-remove="${index + 1}" style="cursor: pointer;">
                  <img src="https://cdn.shopify.com/s/files/1/0261/8441/7357/files/trash.png" alt="remove" style="width:15px;height:15px;margin-top:16px">
                </a>
                <div class="price-wrapper">
                  ${comparePriceHTML}
                  <span class="cart-drawer-item__price">${itemPrice}</span>
                </div>
              </div>
            </div>
          </div>`;
      }).join('');

      itemsContainer.innerHTML = html;
      drawerFooter.style.display = 'block';
      drawerInfo.style.display = 'block';

      const shippedPrice = cart.total_price + (495*cart.item_count);
      totalElementYes.textContent = `PROCEED TO CHECKOUT - ${theme.Currency.formatMoney(cart.total_price)}`;
      totalElementNo.textContent = `Proceed Without Free Shipping - ${theme.Currency.formatMoney(shippedPrice)}`;
      // theme.Cart.prototype._setCartCountBubble(cart.item_count);

    } catch (error) {
      console.error('Cart Drawer Loading Error:', error);
    } finally {
      isLoading = false;
    }
  }

  /*-----------------------------------
    Click events
  -----------------------------------*/
  // if (cartIcon) cartIcon.addEventListener('click', openAndLoadCartDrawer);
//   if (cartIcon) {
//     alert('111');
//   cartIcon.addEventListener('click', function (e) {
//     e.preventDefault();      // stops default action (like link navigation)
//     e.stopPropagation();     // stops bubbling to parent handlers
//     // e.stopImmediatePropagation(); // (optional) stops other listeners on same element

//     openAndLoadCartDrawer();
//   });
// }
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  overlay.addEventListener('click', closeCartDrawer);

  /*-----------------------------------
    Intercept fetch() for /cart/add.js only
  -----------------------------------*/
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    try {
      const requestUrl = new URL(response.url);
      if (requestUrl.pathname === '/cart/add.js') {
        await openAndLoadCartDrawer();
      }
    } catch (err) {
      // console.warn('Fetch interception failed:', err);
    }
    return response;
  };

  /*-----------------------------------
 Quantity + / - Buttons
-----------------------------------*/
  document.addEventListener('click', async function (e) {
    const plusBtn = e.target.closest('.quantity-plus');
    const minusBtn = e.target.closest('.quantity-minus');

    if (plusBtn || minusBtn) {
      const input = (plusBtn || minusBtn).parentElement.querySelector('[data-quantity-input]');
      let newQty = Number(input.value) + (plusBtn ? 1 : -1);
      if (newQty < 0) newQty = 0;
      input.value = newQty;

      const line = input.dataset.quantityItem;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: newQty })
      });

      loadCartDrawer();
    }
  });
  /*-----------------------------------
 Remove item
-----------------------------------*/
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    btn.innerHTML = '<div class="spinner"></div>';
    const line = btn.dataset.cartRemove;
    try {
      const line = Number(btn.dataset.cartRemove);

      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: 0 })
      });

      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }

      const cart = await res.json();

      await loadCartDrawer(cart); // ✅ single call

    } catch (err) {
      console.error('Error removing item:', err);

      btn.innerHTML = `
    <img src="https://cdn.shopify.com/s/files/1/0261/8441/7357/files/trash.png"
         alt="remove"
         style="width:15px;height:15px;margin-top:167px">
  `;
    }
  })
  /*-----------------------------------
 Quantity Change (input)
-----------------------------------*/
  document.addEventListener('input', async function (e) {
    if (!e.target.matches('[data-quantity-input]')) return;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(async () => {
      const line = e.target.dataset.quantityItem;
      const quantity = parseInt(e.target.value, 10);

      // prevent empty/invalid values
      if (isNaN(quantity) || quantity < 0) return;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity })
      });

      loadCartDrawer();
    }, 500);
  });
});
